export const CreatedAt = (props) => {
    const label = props.label;
    const date = new Date(props.date);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const created = date.toLocaleDateString('fr', options).split(' ');
    switch (label) {
        case 'history':
        case 'festival':
            return (
                <div className="dates">
                    <div className="day">{created[1]}</div>
                    <div className="month">{created[2]}</div>
                    <div className="year">{created[3]}</div>
                </div>
            )
        case 'created':
        case 'closed':
            let legend = (label === 'created') ? 'Création' : 'Fermeture';
            return (
                <div className="dates">
                    <div className="created">{legend}</div>
                    <div className="day">{created[1]}</div>
                    <div className="month">{created[2]}</div>
                    <div className="year">{created[3]}</div>
                </div>
            )
        default:
            return (
                <div className="dates">
                    <div className="created">Création</div>
                    <div className="day">{created[1]}</div>
                    <div className="month">{created[2]}</div>
                    <div className="year">{created[3]}</div>
                </div>
            )
    }
}